import { render, staticRenderFns } from "./simOpenWup.vue?vue&type=template&id=4bb48800&scoped=true&"
import script from "./simOpenWup.vue?vue&type=script&lang=js&"
export * from "./simOpenWup.vue?vue&type=script&lang=js&"
import style0 from "./simOpenWup.vue?vue&type=style&index=0&id=4bb48800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb48800",
  null
  
)

export default component.exports